import { useContext } from "preact/hooks"
import { DayContext } from "./contexts/DayContext"

export const eventDays = [
    new Date("2025-10-26T08:45:00+01:00"), // day 1
    new Date("2025-10-27T08:00:00+01:00"), // day 2
    new Date("2025-10-28T08:00:00+01:00"), // day 3
    new Date("2025-10-28T12:30:00+01:00") // On Demand
]

/*
    Sumary:
    - df => default
    - od => on demand
    - Arrays => idx + 1 === day (except for auditorium that has a Hall)
    - [key: string]: Object | array => Custom data for each room
    - onDemand => is event at on demand state? true || false
*/
export default {
    "global": {
        "CongressBackInTime": "https://www.isflive.org/s/congress/back-in-time/",
        "PopupBGDesign": "https://assets.swoogo.com/uploads/full/5969803-68efeaee1232a.png",
        "feedback": "df99bf99-a62f-4a29-8edd-e614ed28a8f2"
    },
    "debug": false,
    "eventId": 249184,
    "lobby": {
        "df": "https://assets.swoogo.com/uploads/full/5988679-68f641a8a0630.png",
        "od": "https://assets.swoogo.com/uploads/full/6023155-6900bcaff213b.png",
        "timedPopups": [
            {
                name: "WelcomePopup",
                always: true,
                displayOnce: true,
                text: [
                    "Hello, and welcome to the ISF World Congress 2025",
                    "It is a pleasure to welcome Members back to our digital platform. Take a look around, listen to our keynotes and hear ISF Members share their experiences and stories, livestreamed from our in-person event at the Prague Congress Centre.",
                    "You will be able to participate live by asking questions via the platform. Please do give us your feedback at the end of each session."
                ]
            },
            {
                name: "DayOnePopup",
                start: eventDays[0],
                end: eventDays[1],
                displayOnce: true,
                text: [
                    "WELCOME TO PRAGUE 2025 ONLINE: DAY ONE",
                    "Today's keynote speakers are Martina Navratilova and Sir Jeremy Fleming.",
                    "Visit the ISF Exploration Zone to access the latest reports and a wealth of resources available only to our Members, and tap into the knowledge of the ISF team.",
                    "Check out the Ontario Showcase how their vendors can help you optimise managing your security landscape.",
                    "Please share your feedback after attending each session."
                ]
            },
            {
                name: "DayTwoPopup",
                start: eventDays[1],
                end: eventDays[2],
                displayOnce: true,
                text: [
                    "WELCOME TO PRAGUE 2025  ONLINE: DAY TWO",
                    "Today's keynote speakers are Dr Helena Boschi and Jaya Baloo. ",
                    "Visit the ISF Exploration Zone to access the latest reports and a wealth of resources available only to our Members and tap into the knowledge of the ISF team. ",
                    "Check out the Ontario Showcase how their vendors can help you optimise managing your security landscape.",
                    "Go to our on demand room to view yesterday's sessions. ",
                    "Please share your feedback after attending each session."
                ]
            },
            {
                name: "DayThreePopup",
                start: eventDays[2],
                end: eventDays[3],
                displayOnce: true,
                text: [
                    "WELCOME TO PRAGUE 2025 ONLINE: DAY THREE",
                    "Today's keynote speakers are Tom Hardin and Rainer Hersch.",
                    "Go to our on demand room to view previous sessions.",
                    "All sessions will be available to view on demand after today's broadcast.",
                    "Please share your feedback after attending each session."
                ]
            },
            {
                name: "OnDemandPopup",
                start: eventDays[3],
                displayOnce: true,
                text: [
                    "THANK YOU FOR ATTENDING PRAGUE 2025 ONLINE",
                    "Following the event we will provide delegates with a certificate of attendance indicating the event date and times, which can be used to support your professional development. ",
                    "The maximum number of hours that can be achieved by attending all online sessions is 15 hours. ",
                    "Attendance certificates will be stored on your ISF Live profile and will be available for download approximately 15 working days after the event.",
                    "The Congress platform will remain open until Tuesday 18 November for you to browse content and watch sessions on demand."
                ]
            }
        ]
    },
    "auditorium": {
        "df": [
            "https://assets.swoogo.com/uploads/full/5995453-68f7c18917712.png", // Auditorium Hall
            "https://assets.swoogo.com/uploads/full/5871977-68d58e0bd1de1.png", // auditorium 1
            "https://assets.swoogo.com/uploads/full/5871978-68d58e0bde54c.png"  // auditorium 2
        ],
        "foyer_doors": {
            "df": [["Auditorium One", "/auditorium-one"], null, ["Auditorium Two", "/auditorium-two"]],
            "od": [["Keynotes", "/keynotes"], ["Studio Interviews", "/studio-interviews"], ["Breakouts", "/breakouts"]]
        },
        "append": ["one", "two"], // auditorium room name replacements for 1, 2
        "streaming": [
            "https://vimeo.com/event/5439054/embed?autoplay=1&muted=0", // auditorium 1
            "https://vimeo.com/event/5439057/embed?autoplay=1&muted=0"  // auditorium 2
        ],
        "useBkp": false,
        "streamingbkp": [
            "https://video.ibm.com/embed/26801399?autoplay=true&showtitle=false", // auditorium 1
            "https://video.ibm.com/embed/26801407?autoplay=true&showtitle=false" // auditorium 2
        ],
        "QA": [
            "https://events.securityforum.org/2025-feedbackaud1",
            "https://events.securityforum.org/2025-feedbackaud2"
        ],
        "slido": [
            "https://app.sli.do/event/6CSqfFUEYezvdWHcEwitqw", // Auditorium one
            "https://app.sli.do/event/6CSqfFUEYezvdWHcEwitqw" // Auditorium two
        ],
        "od": [
            "https://assets.swoogo.com/uploads/full/5871979-68d58e0c00725.png", // Auditorium hall On Demand
            "", // Auditorium 1 On Demand
            "" // Auditorium 2 On Demand
        ]
    },
    "on_demand": {
        df: "https://assets.swoogo.com/uploads/full/5975267-68f12b49c5fa3.png"
    },
    "interviews": {
        df: "https://assets.swoogo.com/uploads/full/6022235-69006ea5757f1.png",
        CTA: "https://www.isflive.org/s/isf-videos-podcasts",
        GRID: [
            {
                style: {
                    gap: "5%",
                    left: "17%",
                    top: "23%",
                    width: "66.5%",
                    height: "23%",
                    columnGap: "1%",
                },
                isModal: true,
                roomName: "interviews",
                links: [
                    [
                        ["Studio Interviews - Sir Jeremy Fleming", "https://player.vimeo.com/video/1127193819?autoplay=1&muted=0", "313d37b8-b242-49dd-8729-e39d35bb1ce5"],
                        ["Studio Interviews - Dr Helena Boschi", "https://player.vimeo.com/video/1127193770?autoplay=1&muted=0", "3892683d-51d9-4bc3-9939-ec3735fd3d3f"],
                        ["Studio Interviews - Jaya Baloo", "https://player.vimeo.com/video/1127193803?autoplay=1&muted=0", "fc944249-ed4a-4a02-8fa6-5de495e8224e"],
                    ]
                ]
            },
            {
                style: {
                    gap: "5%",
                    left: "28%",
                    top: "47%",
                    width: "44.4%",
                    height: "23%",
                    columnGap: "2%",
                },
                isModal: true,
                roomName: "interviews",
                links: [
                    [
                        ["Studio Interviews - Tom Hardin", "https://player.vimeo.com/video/1127193886?autoplay=1&muted=0", "3e27d9e1-7342-488b-af05-163eaad67f5b"],
                        ["Studio Interviews - Rainer Hersch", "https://player.vimeo.com/video/1127193862?autoplay=1&muted=0", "20db6f07-1a1f-40b1-8485-b959de20b810"]
                    ]
                ]
            }
        ]
    },
    "keynotes": {
        df: "https://assets.swoogo.com/uploads/full/6002698-68f938f8da844.png",
        GRID: [
            {
                style: {
                    gap: "11%",
                    left: "28%",
                    top: "9%",
                    width: "44%",
                    height: "80%",
                    columnGap: "2%",
                },
                isModal: true,
                roomName: "keynotes",
                links: [
                    [
                        ["Serving Up the Secrets of Success", "https://player.vimeo.com/video/1125569410?autoplay=1&muted=0&loop=1", "3a708559-62df-4cfa-ade4-7757a3f00148"],
                        ["Cyber Power: Navigating the age of cyber threats and oportunities", "https://player.vimeo.com/video/1125803392?autoplay=1&muted=0&loop=1", "801f29f4-d3a3-4be6-b107-adc54e5b208b"]
                    ],
                    [
                        ["Mind out of joint: Hacking the brain for success at work and life", "https://player.vimeo.com/video/1125842023?autoplay=1&muted=0&loop=1", "9ebb8fad-ac07-4a4a-bb8c-176528074dc9"],
                        ["Qubits, AI & Robots: Adding to the security leader's playbook for the next decade", "https://player.vimeo.com/video/1125842006?autoplay=1&muted=0&loop=1", "7b8d0c86-d06d-4afc-a3b8-fbcad9873d3b"]
                    ],
                    [
                        ["Roles and regulations: The hidden human factors in mitigating risk", "https://player.vimeo.com/video/1125869342?autoplay=1&muted=0", "a2696aa4-c824-4d13-b20c-8f98709be136"],
                        ["Sound advice: What business can learn from a symphony orchestra", "https://player.vimeo.com/video/1125869263?autoplay=1&muted=0", "ab380ff2-a3c4-4a44-862c-598b5a1fa8e1"]
                    ]
                ]
            },
        ]
    },
    "breakouts": {
        df: "https://assets.swoogo.com/uploads/full/5944113-68e7e03747923.png"
    },
    "breakouts_one": {
        df: "https://assets.swoogo.com/uploads/full/6007195-68fa6338ba39b.png",
        GRID: {
            style: {
                gap: "4%",
                left: "5.8%",
                top: "23%",
                width: "88.5%",
                height: "46.5%",
                columnGap: "1%",
            },
            links: [
                [
                    ["Leonie Witte - Building Resilient Security Functions", "https://player.vimeo.com/video/1125803337?autoplay=1&muted=0&loop=1", "82a78fbd-6043-47b4-a97f-31b6f7b4c215"], 
                    ["Stuart Frost - Danget Zone: Where risk meets reward", "https://player.vimeo.com/video/1125803357?autoplay=1&muted=0&loop=1", "9f61f0a3-48df-436e-be4d-e0c354827c54"], 
                    ["Patric J.M Versteeg - Leadership in Cyber Security", "https://player.vimeo.com/video/1125803414?autoplay=1&muted=0&loop=1", "babd4d2f-02bd-4a1e-a55c-b3dc34a2205d"], 
                    ["Thomas Wegner - The Seven Most Essential OT Cyber-Security Controls", "https://player.vimeo.com/video/1125803294?autoplay=1&muted=0&loop=1", "2efe455c-3c04-48e0-bcd3-570123b5814b"]
                ],
                [
                    ["Matt Palmer - Blue Lights and Breaches", "https://player.vimeo.com/video/1125803325?autoplay=1&muted=0&loop=1", "7875ea74-0dc0-4bcc-bd61-2ccfba970741"], 
                    ["Peter East Neil & Fowler Wright - Now \"What should we do?\"", "https://player.vimeo.com/video/1127452123?autoplay=1&muted=0&loop=1", "e2cda1ba-c182-465e-8131-7db2137c2e33"],
                    ["Silje Fossaskaret - Bane NOR`s Journey to a Strategic Goal", "https://player.vimeo.com/video/1125803311?autoplay=1&muted=0&loop=1", "008d8d62-951f-470c-b3ae-53b80f995bf8"],
                    ["Carlo Shreurs - Hack the Mind: The power of Storytelling in cyber and AI leadership", "https://player.vimeo.com/video/1125803377?autoplay=1&muted=0&loop=1", "01a6e9a5-d2b1-4c1d-8619-b3cbccc9ed63"]
                ],
            ]
        }
    },
    "breakouts_two": {
        df: [
            "https://assets.swoogo.com/uploads/full/6007194-68fa6338b9869.png",
            "https://assets.swoogo.com/uploads/full/6007194-68fa6338b9869.png"
        ],
        GRID: [
            {
                style: {
                    gap: "4%",
                    left: "5.8%",
                    top: "10.3%",
                    width: "88.5%",
                    height: "46.5%",
                    columnGap: "1%",
                },
                links: [
                    [
                        ["John Hinchcliffe - Building a flexible framework for cyber risk management", "https://player.vimeo.com/video/1125864017?autoplay=1&muted=0", "7dbed831-7c86-42e8-969e-1e6e5dcd0a70"], 
                        ["Sebastian Avarvarei - Your Security Team is Awesome", "https://player.vimeo.com/video/1125864162?autoplay=1&muted=0", "97f8cf57-06c0-495c-ac37-2bd64a4a90e7"], 
                        ["Shara Terjung & Ben Strijbosh - Building Supply Chain Security", "https://player.vimeo.com/video/1125864040?autoplay=1&muted=0", "af1c68e1-6f5e-45dc-ae28-2cc4d6d03ecc"], 
                        ["James Kwaan - Improve your resilience to Geopolitical Challenges", "https://player.vimeo.com/video/1125864065?autoplay=1&muted=0", "93c7764f-dfdb-4ca4-90ed-740ea65b2245"]
                    ],
                    [
                        ["Emmerentia Du Plooy & Tshepo Shongwe - Maturing a Third-party risk assessment by leveraging the ISF SOGP", "https://player.vimeo.com/video/1125864091?autoplay=1&muted=0", "a74f625e-dc4a-43a1-8cab-f7791bf32649"], 
                        ["Antti Evesti - Unlocking the Power of Security Metrics", "https://player.vimeo.com/video/1125864134?autoplay=1&muted=0", "d756aba0-63d2-4e61-96f2-11fa8448c932"],
                        ["Zero Trust? Zero Problems!", "https://player.vimeo.com/video/1125863988?autoplay=1&muted=0", "9e2a5d07-3284-41f5-a5aa-e8448f69661a"],
                        ["Dieudonnée Penning - The BISO Journey", "https://player.vimeo.com/video/1125864122?autoplay=1&muted=0", "bf9b31e4-9fde-48d6-951a-7374cf3d0805"]
                    ],
                ]
            },
            {
                style: {
                    gap: "4%",
                    left: "28%",
                    top: "67.3%",
                    width: "43.9%",
                    height: "22%",
                    columnGap: "2%",
                },
                links: [
                    [
                        ["Oliver Allaire - How Airbus used Scenario Planning to Identify Cyber Exposure", "https://player.vimeo.com/video/1125869282?autoplay=1&muted=0&loop=1", "2dbcd099-39eb-409e-bf9a-c7f63a4b71ab"], 
                        ["Timo Wiander - Implementing the Design basis Threat Concept", "https://player.vimeo.com/video/1125869307?autoplay=1&muted=0&loop=1", "99492904-722d-43de-a4ca-1bbebc747063"], 
                    ]
                ]
            }
        ]
    },
    "expo_hall": {
        df: "https://assets.swoogo.com/uploads/full/5926529-68e40dd75683e.png",
        booths: {
            "Capzul": "1f30d502-d264-45f3-ae35-c2266bcffba1",
            "CyBeats": "1e63c312-ef64-470e-9b3f-951eb10a46ff",
            "eSentire": "02a83ba6-61a8-4f19-8193-33b1bbfcad65",
            "FerroTechnics": "d6303c17-a541-4c39-ab7a-cd3598392f20",
            "Parabellyx": "f7a66a70-64da-45f1-a19a-e2f5bbda3959",
            "SecurityCompass": "bdfaa100-1e52-4afa-b314-cd6283a65152"
        },
        achievements: {
            download_file: {
                "Capzul": "74562961-824b-4080-8ca9-6bf77ca0a417",
                "CyBeats": "f20eb360-1426-4889-bbc4-25a1559c0299",
                "eSentire": "fc9c073c-7302-49d3-ac2f-01e93ec6926a",
                "FerroTechnics": "75ba0b59-0ae0-464d-b37c-76d6d6bcac28",
                "Parabellyx": "fb13a9ca-5690-4834-8806-1d12185126ff",
                "SecurityCompass": "02f35de3-6ed5-4032-ae59-2fde48dcce28"
            },
            company_link: {
                "Capzul": "4af9052e-da14-4e8e-97c2-4cfd74e34ac4",
                "CyBeats": "809ceced-ec52-42a5-8da5-b759d177afe3",
                "eSentire": "7bead150-6df5-46f6-a7bc-c52ea4233a1a",
                "FerroTechnics": "bdb4077d-9f8d-4489-a3d9-310212f87fe5",
                "Parabellyx": "c4b63b1e-d5b2-4192-a7a0-498b8787110f",
                "SecurityCompass": "e93f7ebb-a379-4279-a7a1-85a98f774275"
            },
            follow_up: {
                "Capzul": "9f0945e3-5796-4e6b-b942-ed8b974c8922",
                "CyBeats": "ab964792-4aeb-4753-b88b-0a98c5dafe98",
                "eSentire": "d87a3a3f-f815-4dbf-a244-fa45f4b6e2e1",
                "FerroTechnics": "91547cb4-bb56-4b3b-b033-ba69783cf350",
                "Parabellyx": "ffda413b-40da-4988-bae2-52e7cbf823f8",
                "SecurityCompass": "a3de3b36-4d2e-4ec7-b610-5a4126394f28"
            },
            video_popup: {
                "Capzul": "6195bd96-b4a3-4c59-9793-083e3ec20322",
                "CyBeats": "f7013139-361f-44fb-a2dc-1a22b84aab7c",
                "eSentire": "4f4c948d-fb4c-4abd-92b6-764939cd0089",
                "FerroTechnics": "edf30f24-a323-4ffd-8e8b-82c9d097d5f4",
                "Parabellyx": "cd5123ff-0639-43f4-afb0-4cb4b067409e",
                "SecurityCompass": "883eb9a2-d354-493b-800c-1ac375776a61"
            }
        }
    },
    "exploration_zone": {
        // "df": new Array(4).fill("https://assets.swoogo.com/uploads/full/5932017-68e54ecf40826.jpg"),
        "df": new Array(4).fill("https://assets.swoogo.com/uploads/full/6014839-68fc96d63bcb8.png"),
        "od": "",
        "video": "https://player.vimeo.com/video/1119125884?autoplay=1&muted=0&loop=1",
        "screens": {
            todayPodcast: "https://assets.swoogo.com/uploads/full/5877296-68d6d62a909cc.png"
        },
        "popups": {
            leftScreen: new Array(4).fill({
                image: "https://assets.swoogo.com/uploads/full/5932350-68e55a7c188d2.png",
                video: "https://player.vimeo.com/video/1119120536?autoplay=1&muted=0&loop=1",
                useGRID: true,
                closeBtnOverwrite: {
                    right: "8.5%",
                    top: "11%"
                },
                GRID: {
                    style: {
                        gap: "10px",
                        left: "7%",
                        top: "65.5%",
                        width: "86.3%",
                        height: "15.5%",
                        columnGap: "10px",
                    },
                    links: [
                        [
                            ["Threat Horizon", "https://www.isflive.org/s/threat-horizon?utm_source=tk_digital&utm_medium=digital_platform&utm_campaign=2025_Congress_Prague&utm_id=2025_Congress_Prague", "a375916c-52ce-49ac-8df2-14c28be77b14"], 
                            ["Protect the Crown Jewels", "https://www.isflive.org/s/protecting-the-crown-jewels?utm_source=tk_digital&utm_medium=digital_platform&utm_campaign=2025_Congress_Prague&utm_id=2025_Congress_Prague", "d9969d47-e4c9-4b93-a86f-0ec9f9891c2f"]
                        ],
                        [
                            ["ISF Assure: Your path to better cybersecurity", "https://www.isflive.org/s/article/isf-assure?utm_source=tk_digital&utm_medium=digital_platform&utm_campaign=2025_Congress_Prague&utm_id=2025_Congress_Prague", "fd23c60f-04d1-42ad-8feb-e7b4ecac3e49"], 
                            ["Security Culture suite", "https://www.isflive.org/s/get-started/security-culture?utm_source=tk_digital&utm_medium=digital_platform&utm_campaign=2025_Congress_Prague&utm_id=2025_Congress_Prague", "6d5a630b-6ebb-4281-81ab-980d2b7bfae4"]
                        ],
                        [
                            ["AI Insights", "https://interactive.isflive.org/research-hub/ai-insights/?utm_source=tk_digital&utm_medium=digital_platform&utm_campaign=2025_Congress_Prague&utm_id=2025_Congress_Prague", "cc0f32ca-e732-4203-b8d7-ca2591c4edce"], 
                            ["Cyber Simulation Exercises", "https://www.isflive.org/s/services-overview/cyber-resilience?utm_source=tk_digital&utm_medium=digital_platform&utm_campaign=2025_Congress_Prague&utm_id=2025_Congress_Prague", "640ab02e-4687-4a62-98fa-21d46e0818f5"]
                        ],
                    ]
                },
                ACTION_BTN: "mailto:services@securityforum.org?utm_source=tk_digital&utm_medium=digital_platform&utm_campaign=2025_Congress_Prague&utm_id=2025_Congress_Prague",
                ACTION_BTN_LABEL: "Need Help? Get in touch with our experts",
                ACTION_BTN_style: {
                    height: "5.1%",
                    left: "31.5%",
                    top: "84%",
                    width: "37%",
                }
            }),
            rightScreen: new Array(4).fill({
                image: "https://assets.swoogo.com/uploads/full/5932845-68e56b24e431c.png",
                video: "https://player.vimeo.com/video/1119110043?utm_source=tk_digital&utm_medium=digital_platform&utm_campaign=2025_Congress_Prague&utm_id=2025_Congress_Prague&autoplay=1&muted=0&loop=1",
                useGRID: true,
                closeBtnOverwrite: {
                    right: "8.5%",
                    top: "11%"
                },
                GRID: {
                    style: {
                        gap: "10px",
                        left: "7%",
                        top: "69.5%",
                        width: "86.3%",
                        height: "12.5%",
                        columnGap: "10px",
                    },
                    links: [
                        [
                            ["DORA/NIS2", "https://www.isflive.org/s/services-overview/cyber-regulation?utm_source=tk_digital&utm_medium=digital_platform&utm_campaign=2025_Congress_Prague&utm_id=2025_Congress_Prague", "15632227-2622-409c-bb46-042ef927ae14"], 
                            ["CRA Assurance Service", "https://www.isflive.org/s/services-overview/cyber-regulation#CRA?utm_source=tk_digital&utm_medium=digital_platform&utm_campaign=2025_Congress_Prague&utm_id=2025_Congress_Prague", "7abacc34-e90e-45c5-9fde-9be8b0340667"]
                        ],
                        [
                            ["Risk Assessment and Review", "https://www.isflive.org/s/services-overview/risk-assessment-and-review?utm_source=tk_digital&utm_medium=digital_platform&utm_campaign=2025_Congress_Prague&utm_id=2025_Congress_Prague", "bd05f487-c364-4b0f-874e-abafdbd16038"], 
                            ["ISF Services: The natural extension of your cyber security team", "https://www.isflive.org/s/services-overview?utm_source=tk_digital&utm_medium=digital_platform&utm_campaign=2025_Congress_Prague&utm_id=2025_Congress_Prague", "094f48c4-7d47-4a43-8fd9-492e36742dd1"]
                        ],
                    ]
                },
                ACTION_BTN: "mailto:services@securityforum.org?utm_source=tk_digital&utm_medium=digital_platform&utm_campaign=2025_Congress_Prague&utm_id=2025_Congress_Prague",
                ACTION_BTN_LABEL: "Let's talk - how can we help?",
                ACTION_BTN_style: {
                    height: "5.1%",
                    left: "31.5%",
                    top: "84%",
                    width: "37%",
                } 
            }),
            leftBoard: [
                ["https://assets.swoogo.com/uploads/full/6013622-68fbcda31a065.png", "https://open.spotify.com/embed/episode/6GUqT0HZgrYEsFpKtjVjEi?utm_source=generator", null, "d64ede32-6cc2-417b-a79e-3eeb0fcdaf1a"], // day 1
                ["https://assets.swoogo.com/uploads/full/6013621-68fbcda317e31.png", "https://open.spotify.com/embed/episode/5f57ZKupNFF97b9EmU6J8s?utm_source=generator", null, "262c3c89-0be6-4110-b9a8-92df5f16686b"], // day 2
                ["https://assets.swoogo.com/uploads/full/6013620-68fbcda316764.png", "https://open.spotify.com/embed/episode/0PhRwvNqGx0IALOcxvuU4F?utm_source=generator", null, "7176b5cf-be71-4e40-8606-6a08adda3032"],  // day 3
                ["https://assets.swoogo.com/uploads/full/5947862-68e857678788d.png", [
                    [["Leading with Vision and Empathy: The North Star approach", "https://www.isflive.org/s/community-webcast/a2EQC000005TRgH2AW/leading-with-vision-and-empathy-the-north-star-approach?utm_source=tk_digital&utm_medium=digital_platform&utm_campaign=2025_Congress_Prague&utm_id=2025_Congress_Prague", "d64ede32-6cc2-417b-a79e-3eeb0fcdaf1a"]],
                    [["Rest after stress: The psychology of high performance", "https://www.isflive.org/s/community-webcast/a2EQC000005DqNh2AK/rest-after-stress-the-psychology-of-high-performance?utm_source=tk_digital&utm_medium=digital_platform&utm_campaign=2025_Congress_Prague&utm_id=2025_Congress_Prague", "262c3c89-0be6-4110-b9a8-92df5f16686b"]],
                    [["Stay Ahead of Fall Behind: The AI Challenge for modern businesses", "https://www.isflive.org/s/community-webcast/a2EQC000004tVk12AE/stay-ahead-or-fall-behind-the-ai-challenge-for-modern-businesses?utm_source=tk_digital&utm_medium=digital_platform&utm_campaign=2025_Congress_Prague&utm_id=2025_Congress_Prague", "7176b5cf-be71-4e40-8606-6a08adda3032"]]
                ], 
                {
                    GRID: {
                        style: {
                            gap: "7%",
                            left: "7%",
                            top: "31%",
                            width: "86.3%",
                            height: "31%"
                        },
                    }
            }] // OD
            ].map(([image, link, grid, achievement]) => ({
                image, link, grid, achievement
            })),
            rightBoard: new Array(4).fill({ // 3 days are the same stuff
                image: "https://assets.swoogo.com/uploads/full/5877903-68d6eb7f6c0ef.png",
                video: "https://player.vimeo.com/video/1115480094?autoplay=1&muted=0&loop=1",
                ACTION_BTN: "https://www.isflive.org/s/contact-us?utm_source=tk_digital&utm_medium=digital_platform&utm_campaign=2025_Congress_Prague&utm_id=2025_Congress_Prague",
                ACTION_BTN_LABEL: "Get in touch with your account manager",
                ACTION_BTN_ACHIEVEMENT: "5950a46b-573b-45e3-a15d-3ad0386448dc",
                topLeft: "https://interactive.isflive.org/member/whats-coming-up/?utm_source=tk_digital&utm_medium=digital_platform&utm_campaign=2025_Congress_Prague&utm_id=2025_Congress_Prague",
                topLeftLabel: "Whats coming up in the ISF",
                topLeftAchievement: "6bc0e21f-e00f-4df1-956b-1e323b7cd634",
                topRight: "https://interactive.isflive.org/member/whats-coming-up/chapter-events?utm_source=tk_digital&utm_medium=digital_platform&utm_campaign=2025_Congress_Prague&utm_id=2025_Congress_Prague",
                topRightLabel: "Join your local chapter meeting",
                topRightAchievement: "dabb0dcc-7aa6-43c4-9a61-54699fe70caa",
                bottom: "https://www.isflive.org/s/get-started?utm_source=tk_digital&utm_medium=digital_platform&utm_campaign=2025_Congress_Prague&utm_id=2025_Congress_Prague",
                bottomLabel: "Get started on ISF Live",
                bottomAchievement: "cd182d90-d46f-4b23-aee1-3920182d74f9"
            })
        }
    },
    onDemand: getDayStandalone() === 4,
    isOnDemand() {
        try {
            return getDay() > 2
        } catch {
            return getDayStandalone() === 4
        }
    }
}

export const colors = {
    purple: "#4A004D",
    teal: "#05756B",
    aqua: "#05B299",
    lavender: "#9982AB"
}

function getDayStandalone() {
    const idx = eventDays.findLastIndex(v => new Date().getTime() > v.getTime())
    return idx === -1 ? 0 : idx
}

export function getDay(forced = null) {
    const context = useContext(DayContext)
    if (forced) return forced
    if (context && context.date.day !== null) return context.date.day

    return getDayStandalone()
}